import React from 'react';
import { isAiInput, SourceType } from '@/modules/surgicalEvent';
import { EpicBadge } from './EpicBadge';
import { AiBadge } from './AiBadge';
import { OcrBadge } from './OcrBadge';
import { AutomationBadge } from './AutomationBadge';
import { PatientsAppBadge } from './PatientsAppBadge';

export const SourceTypeBadge = ({
  sourceType,
  justification
}: {
  sourceType: SourceType | undefined;
  justification?: string;
}) => (
  <>
    {isAiInput(sourceType) && (
      <AiBadge sourceType={sourceType} justification={justification} />
    )}
    {sourceType === SourceType.OCR && <OcrBadge />}
    {sourceType === SourceType.EPIC && <EpicBadge />}
    {sourceType === SourceType.PATIENTS_APP && <PatientsAppBadge />}
    {sourceType === SourceType.AUTOMATION && <AutomationBadge />}
  </>
);
